import React, { createContext, useContext } from 'react';
import { IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

export const PageMenuContext = createContext(null);

export default function PageMenuButton() {
  const menu = useContext(PageMenuContext);
  if (!menu?.enabled) return null;

  return (
    <IconButton
      onClick={menu.onToggleSidebar}
      aria-label={menu.sidebarOpen ? 'Fechar menu lateral' : 'Abrir menu lateral'}
      size="small"
      sx={{ ml: -0.5, flexShrink: 0, width: 40, height: 40 }}
    >
      <MenuIcon />
    </IconButton>
  );
}
